const config = JSON.parse(localStorage.getItem("config"));
const initialState = config ? { config } : { darktheme: false };

export const configs = {
  namespaced: true,
  state: initialState,
  actions: {
  },
  mutations: {
    changeConfigs(state) {
      let config = JSON.parse(localStorage.getItem("config"));
      state.darktheme = config.darktheme;
    },
  },
};
